export default {
  Menu: {
    account: 'Cuenta',
    alterar_conta: 'Alterar Cuenta',
    trocar_senha: 'Cambiar Contraseña',
    gerenciar_usuarios: 'Administrar Usuarios',
    indique_ganhe: 'Indique y gane',
    about_the_user: 'Tu usuário',
    alterar_idioma: 'Cambiar Idioma',
    config_area: 'Configurar área',
    users: 'Usuarios',
    edit_user: 'Editar usuario',

    PasswordModal: {
      type_here: 'Escribe aquí',
      current_password: 'Contraseña actual',
      new_password: 'Nueva contraseña',
      confirm_password: 'Confirmar contraseña',
    },
  },
}
